import { render, staticRenderFns } from "./BlogPostsMenu.vue?vue&type=template&id=7f31acc3&"
import script from "./BlogPostsMenu.vue?vue&type=script&lang=js&"
export * from "./BlogPostsMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports